module.exports = __webpack_public_path__ + "static/media/background.bba3190e.png";